import { render } from "./IncomingCallPopup.vue?vue&type=template&id=6ab4fdc1&scoped=true"
import script from "./IncomingCallPopup.vue?vue&type=script&lang=js"
export * from "./IncomingCallPopup.vue?vue&type=script&lang=js"

import "./IncomingCallPopup.vue?vue&type=style&index=0&id=6ab4fdc1&scoped=true&lang=less"

import exportComponent from "C:\\Users\\bartelmus\\Desktop\\git\\spiel26-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ab4fdc1"]])

export default __exports__